( function() {
	'use strict';

	document.addEventListener( 'DOMContentLoaded', function() {
		const containers = document.querySelectorAll( '[data-module=hero] .state-select-container' );

		containers.forEach( function( container ) {
			const buttons = container.querySelectorAll( '.state-select-button-container button' );
			const selects = container.querySelectorAll( '.individual-state-select select' );

			if ( !buttons.length || !selects.length ) {
				return;
			}

			const stateFromUrl = ( new URLSearchParams( window.location.search ).get( 'state' ) || '' ).trim();
			if ( stateFromUrl ) {
				selects.forEach( function( select ) {
					if ( !( select instanceof HTMLSelectElement ) ) {
						return;
					}
					const match = Array.prototype.find.call( select.options, function( option ) {
						return option.value.toUpperCase() === stateFromUrl.toUpperCase();
					} );
					if ( match ) {
						select.value = match.value;
					}
				} );
			}

			container.addEventListener( 'click', function( event ) {
				const target = event.target;
				if ( !( target instanceof Element ) ) {
					return;
				}
				const button = target.closest( '.state-select-button-container button' );
				if ( !button || !container.contains( button ) ) {
					return;
				}

				const firstSelect = selects[0];
				if ( !( firstSelect instanceof HTMLSelectElement ) ) {
					return;
				}

				const selectedState = firstSelect.value;
				if ( selectedState !== 'none' ) {
					window.location.href =
						window.location.origin +
						window.location.pathname +
						'?state=' +
						selectedState;
				}
			} );
		} );
	} );
} )();
